import Header from './components/Header'
import HomeHero from './components/home/HomeHero'
import HomeBoutique from './components/home/HomeBoutique'
import HomeTraiteur from './components/home/HomeTraiteur'
import HomeSectionIntroduction from './components/home/HomeSection_Introduction'
import HomeClub from './components/home/HomeClub'
import HomeAteliers from './components/home/HomeAteliers'

import FooterNew from './components/FooterNew'
import HomeFinancement from './components/home/HomeFinancement'


function Home() {


  return (
    <>
      <Header/>
      <HomeHero/>
      <HomeSectionIntroduction/>
      <HomeBoutique/>
      <HomeAteliers/>
      <HomeTraiteur/>
      <HomeFinancement/>

      <HomeClub/>
      <FooterNew/>
    </>
  )
}

export default Home